'use client'

import { useTranslate } from '@repo/shared/hooks'
import { Card, Typography, Alert, Row, Col } from '@repo/ui/components'
import { FeeCTA } from './fee.cta'
import { useIsDesktop } from '@repo/ui/hooks'
import { InformationDialog, PaymentType } from '@repo/shared/components'
import { useUserPerformance } from '@repo/services'

export const FeeContainer = () => {
  const { t, tRich } = useTranslate()
  const { data } = useUserPerformance()

  const isDesktop = useIsDesktop()

  const otcFees =
    data?.data.levels?.map((level) =>
      level.fee ? Math.round(level.fee * 100 * 100) / 100 : 0,
    ) ?? []

  return (
    <Card className='!gap-3xl' withoutBorder>
      {isDesktop && <FeeCTA origin='container' />}
      <Typography size='xs' weight='regular' color='text-neutral-surface-100'>
        {t('profileFeePage_fee_description')}
      </Typography>
      <Row>
        <Col className='items-center gap-md'>
          <Typography
            size='xs'
            weight='regular'
            color='text-neutral-surface-100'
          >
            {t('profileFeePage_fee_volume')}
          </Typography>
          <PaymentType
            value={data?.data.otcVolume ? data?.data.otcVolume : 0}
            size='md'
            numberSize='md'
            numberColor='text-neutral-surface-100'
            color='text-neutral-surface-100'
          />
        </Col>
        <Col className='items-center gap-md'>
          <Row className='gap-2xs w-fit'>
            <Typography
              size='xs'
              weight='regular'
              color='text-neutral-surface-100'
            >
              {t('profileFeePage_fee_level')}
            </Typography>
            <InformationDialog title={t('profileFeePage_fee_level')}>
              <div className='whitespace-pre-line mb-md'>
                {t('info_fee_amount')}
              </div>
              <Col className='gap-sm'>
                {otcFees.map((value, index) => (
                  <Row className='space-between' key={index}>
                    <Typography
                      variant='p'
                      size='xs'
                      weight='regular'
                      color='text-neutral-surface-100'
                      className='w-full'
                    >
                      {t(`info_trading_volume_${index + 1}`)}
                    </Typography>
                    <Typography
                      size='xs'
                      weight='regular'
                      color='text-neutral-surface-100'
                      className='whitespace-nowrap'
                    >
                      <span className='font-bold text-sm'>{value}</span>{' '}
                      {t('common_percentage')}
                    </Typography>
                  </Row>
                ))}
              </Col>
            </InformationDialog>
          </Row>
          <Typography size='md' weight='bold'>
            <Typography
              size='xs'
              weight='regular'
              color='text-neutral-surface-80'
              className='px-2xs'
            >
              %
            </Typography>
            {data?.data.otcFee
              ? Math.round(data?.data.otcFee * 100 * 100) / 100
              : 0}
          </Typography>
        </Col>
      </Row>

      {data?.data.otcFee &&
        otcFees.length > 0 &&
        otcFees[otcFees.length - 1] !== data?.data.otcFee && (
          <Alert
            color='base'
            size='sm'
            hideIcon
            caption={tRich.rich('profileFeePage_fee_reduction_message', {
              volume: () => (
                <Typography
                  size='xs'
                  weight='regular'
                  color='text-base-surface-100'
                >
                  <PaymentType
                    value={data?.data.untilNextLevel ?? 0}
                    size='xs'
                    numberSize='xs'
                    numberColor='text-base-surface-100'
                    color='text-base-surface-100'
                  />
                </Typography>
              ),
              fee: () => (
                <Typography
                  size='xs'
                  weight='regular'
                  color='text-base-surface-100'
                >
                  {data?.data.nextLevelFee
                    ? Math.round(data?.data.nextLevelFee * 100 * 100) / 100
                    : 0}
                </Typography>
              ),
            })}
            icon={undefined}
            className='text-center'
          />
        )}
    </Card>
  )
}
